import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import { setBreadcrumb } from "../actions/common";

const styles = {
  text: {
    padding: "50px",
    margin: 0,
  },
};

const NotFound = (props) => {
  const { classes } = props;

  React.useEffect(() => {
    props.dispatch(
      setBreadcrumb([
        {
          name: I18n.get("site_notFound"),
        },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container direction="column" className="height-100">
      <Grid item xs className="mainContainer">
        <Box className="mainContent">
          <Box className={classes.text}>
            <h2>Page Not Found</h2>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default connect()(withStyles(styles)(NotFound));
